// Sheets of the frame open under the classification strip (it is never covered, DESIGN-SYSTEM §00.3, §10.1): @ncp/ui's SheetContent takes
// its top and height from inline style, which this overrides. WP-SHELL.
export const BELOW_STRIP = {
  top: "var(--econic-banner-h, 24px)",
  height: "calc(var(--ncp-vh, 100dvh) - var(--econic-banner-h, 24px))",
} as const;
